import { dto_StartupPageLoadInfo } from "../../../../classes/dto-mobile-settings";
import { dto_cart_checkout } from "../../../../classes/dto-cart-checkout";
import { F_Fammily } from "../../../../util/config-fonts";
import React from "react";
import "../../../../styles/css/pg-cart-promo.css";

export default class Promo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayAddText: "none",
      displayRemoveText: "none",
    };
  }

  render() {
    return (
      <div
        className="fadeInUp animated"
        data-wow-duration="300ms"
        data-wow-delay="0ms"
      >
        {this.props.CustomerPromoCount > 0 ? (
          this.DisplayPromoCode()
        ) : (
          <div className="pgPromoLayout" style={{ margin: 6, display: "flex" }}>
            <div className="pgPromoLayoutCol">
              <img alt="" src={require("../../images/promo.png")} />
            </div>
            <div className="pgPromoLayoutCol">
              <p
                style={{
                  width: "100%",
                  margin: 0,
                  padding: 15,
                  fontWeight: "bold",
                }}
              >
                Add Promo
              </p>
            </div>
          </div>
        )}
      </div>
    );
  }

  DisplayPromoCode() {
    if (dto_StartupPageLoadInfo.isPromoEnabled === true) {
      return (
        <div style={{ marginTop: "0px" }}>
          <div
            style={{
              textAlign: "center",
              border: "none",
              borderRadius: "8px",
              display: "grid",
              gridTemplateColumns:
                dto_cart_checkout.PromoGuid !== 0
                  ? "50px auto 80px 40px"
                  : "50px auto 90px",
              width: "100%",
              alignItems: "center",
              height: "50px",
            }}
          >
            <div
              className="pgPromoLayoutCol"
              style={{ margin: 6, display: "flex" }}
            >
              <img
                style={{ width: "70%" }}
                alt=""
                src={require("../../images/promo3.png")}
              />
            </div>

            <div className="pgPromoLayoutCol">
              <p
                style={{
                  width: "100%",
                  margin: 0,
                  padding: 3,
                  fontWeight: "bold",
                }}
              >
                {this.props.PromoHeader} {this.props.PromoCode}
              </p>
            </div>

            <div
              className="pgPromoLayoutCol"
              style={{
                display: this.props.CustomerPromoCount > 0 ? "flex" : "none",
                justifyContent: "flex-end",
                marginRight: "5px",
              }}
            >
              <i
                className="bi bi-caret-right-fill"
                aria-hidden="true"
                style={{
                  fontSize: "18px",
                  marginTop: "5px",
                  marginRight: "10px",
                }}
                onClick={() => {
                  this.props.PromoAdd();
                }}
              />
            </div>

            {dto_cart_checkout.PromoGuid !== 0 && (
              <div className="pgPromoLayoutCol">
                <p
                  style={{
                    margin: 0,
                    paddingLeft: "10px",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    dto_cart_checkout.PromoGuid = 0;
                    dto_cart_checkout.PromoCODE = "";
                    dto_cart_checkout.PromoHeader = "";
                    this.props.PromoRemove();
                  }}
                >
                  <i
                    className="bi bi-trash"
                    style={{
                      fontSize: "18px",
                      fontFamily: F_Fammily.Medium,
                    }}
                  ></i>
                </p>
              </div>
            )}
          </div>

          <div>
            <div style={{ margin: 0 }}>
              <p
                style={{
                  fontSize: 14,
                  color: "green",
                  textAlign: "center",
                  marginTop: "6px",
                  marginBottom: 0,
                  display: dto_cart_checkout.PromoGuid > 0 ? "block" : "none",
                }}
              >
                {dto_cart_checkout.PromoGuid !== 0
                  ? "Promotion Applied"
                  : "You have " + this.props.CustomerPromoCount + " promotion"}
              </p>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}
